// extracted by css-extract-rspack-plugin
export default {"input":"FixedLengthInput_input__zAADm"};